import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminUsersAddPage = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    // TODO: Integrate with API
    alert('Admin user created!');
    navigate('/admin/users');
  };

  return (
    <div style={{ padding: 24 }}>
      <h1>Tambah Admin</h1>
      <form onSubmit={handleSubmit} style={{ maxWidth: 400 }}>
        <div className="mb-3">
          <label>Nama</label>
          <input name="name" value={form.name} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Email</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Password</label>
          <input name="password" type="password" value={form.password} onChange={handleChange} className="form-control" required />
        </div>
        <button type="submit" className="btn btn-primary">Simpan</button>
      </form>
    </div>
  );
};

export default AdminUsersAddPage;
